
export default {
  // sentences----
  "/sentences/classify/list":{
    page: 1,
    pageSize: 10,
    totalCount: 20,
    totalPages: 2,
    list: [
      {
        id: 1,
        classifyId: 1,
        classifyName: '问候',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
      {
        id: 2,
        classifyId: 2,
        classifyName: '购物',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
    ],
  },
  "/sentences/list":{
    page: 1,
    pageSize: 10,
    totalCount: 20,
    totalPages: 2,
    list: [
      {
        id: 1,
        classifyId: 1,
        classifyName: '问候',
        sentence: '你好',
        explain: 'สวัสดี',
        audioList: ['', '', ''],
        vocabularyList:[
          { id: 1, vocabulary: '你好1', vocabularyExplan: 'สวัสดี' },
          { id: 2, vocabulary: '你好2', vocabularyExplan: 'สวัสดี' },
          { id: 3, vocabulary: '你好3', vocabularyExplan: 'สวัสดี' },
        ],
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
    ],
  },
  "/words/classify/list":{
    page: 1,
    pageSize: 10,
    totalCount: 20,
    totalPages: 2,
    list: [
      {
        id: 1,
        classifyId: 1,
        classifyName: 'ก',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
      {
        id: 2,
        classifyId: 2,
        classifyName: 'ข',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
      {
        id: 3,
        classifyId: 3,
        classifyName: 'ค',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
    ],
  },
  "/words/list":{
    page: 1,
    pageSize: 10,
    totalCount: 20,
    totalPages: 2,
    list: [
      {
        id: 1,
        classifyId: 2,
        classifyName: 'ค',
        word: '你好',
        explain: 'สวัสดี',
        audioList: ['', '', ''],
        vocabularyList:[
          { id: 1, vocabulary: '你好1', vocabularyExplan: 'สวัสดี', vocabularyAudio: '' },
          { id: 2, vocabulary: '你好2', vocabularyExplan: 'สวัสดี', vocabularyAudio: '' },
          { id: 3, vocabulary: '你好3', vocabularyExplan: 'สวัสดี', vocabularyAudio: '' },
        ],
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
    ],
  },
};
